import {useStyles} from '@wix/tpa-settings/react'
import {HEADER_LAYOUT} from '@wix/wix-events-commons-statics'
import React from 'react'
import stylesParams from '../../../../stylesParams'
import {ClassicLayout} from './classic-layout/classic-layout'
import {HeaderProps} from './interfaces'
import {SideBySideLayout} from './side-by-side-layout/side-by-side'

export const Header: React.FC<HeaderProps> = ({onClickRegistrationButton}) => {
  const {get} = useStyles()
  const headerLayout = get(stylesParams.headerLayout)

  return headerLayout === HEADER_LAYOUT.SIDE_BY_SIDE ? (
    <SideBySideLayout onClickRegistrationButton={onClickRegistrationButton} />
  ) : (
    <ClassicLayout onClickRegistrationButton={onClickRegistrationButton} />
  )
}
